module.exports = "/_next/static/images/DiscoverAndActivate@2x-52438fcd3f31fe4ddacb25fbdff87f4e.webp";